module.exports = __webpack_public_path__ + "img/293.cfba8727.png";